module.exports = "pegasus/assets/blocks/column-13-tech.png";